import { Slice } from "./activeStepSlice";

const { actions } = Slice;

export const setStep = (queryParams: any) => (dispatch: (arg0: { payload: any; type: string; }) => void) => {
  // dispatch(actions.startCall({ callType: callTypes.list }));
  return dispatch(actions.stepSet( queryParams ));
};